var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"success-vacancy-modal",attrs:{"name":"successSubmitVacancyForm","height":"auto","adaptive":true,"scrollable":true}},[_c('b-card-header',[_c('b-card-title',[_vm._v(_vm._s(_vm.$t('modals.vacancyWasSended'))+"  🐾  🐕")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }